module.exports = __webpack_public_path__ + "static/media/february.9055a8f0.png";